/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type AccountCategoryEnum = 'INTERNAL' | 'EXTERNAL' | 'POC' | 'ENGINEERING';

export const AccountCategoryEnum = {

    INTERNAL: 'INTERNAL' as AccountCategoryEnum,

    EXTERNAL: 'EXTERNAL' as AccountCategoryEnum,

    POC: 'POC' as AccountCategoryEnum,

    ENGINEERING: 'ENGINEERING' as AccountCategoryEnum
};

